import React from 'react';
import { styled } from '@compiled/react';
import Button from '@atlaskit/button/standard-button';
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import PeopleAndTasksIllustration from '@atlassian/jira-illustrations/src/ui/adg4/jira/heroes/components/people-and-tasks/index.tsx';
import { FormattedMessage } from '@atlassian/jira-intl';
import { fireUIAnalytics, useAnalyticsEvents } from '@atlassian/jira-product-analytics-bridge';
import messages from '../../../messages.tsx';
import { useTeamPermissions } from '../../../services/use-team-permissions/index.tsx';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Description = styled.p({
	color: token('color.text'),
	marginBottom: token('space.300'),
	marginTop: token('space.0'),
});

const imageWrapperStyles = xcss({
	marginBottom: 'space.200',
});

type TeamPickerEmptyStateProps = {
	onActionClick: () => void;
};

export const TeamPickerEmptyState = ({ onActionClick }: TeamPickerEmptyStateProps) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const { canCreateTeams } = useTeamPermissions();

	const handleCreateTeamOptionClick = () => {
		fireUIAnalytics(createAnalyticsEvent({}), 'button clicked', 'createTeamInline', {
			teamsFieldEmptyState: true,
		});
		onActionClick();
	};

	return canCreateTeams ? (
		<Box
			paddingBlock="space.200"
			testId="issue-field-team.ui.edit-mode.team-picker-empty-state.empty-state"
		>
			<Box xcss={imageWrapperStyles}>
				<PeopleAndTasksIllustration alt="" width={130} height={122} />
			</Box>
			<Description>
				<FormattedMessage {...messages.emptyStateDescription} />
			</Description>
			<Button
				appearance="primary"
				onClick={handleCreateTeamOptionClick}
				testId="issue-field-team.ui.edit-mode.team-picker-empty-state.create-team-button"
				interactionName="auto-generated.issue-field-team.ui.edit-mode.team-picker-empty-state.create-team-button.button"
			>
				<FormattedMessage {...messages.createTeamButtonText} />
			</Button>
		</Box>
	) : (
		<FormattedMessage {...messages.noOptionsMessage} />
	);
};
